import { Auth } from "aws-amplify";

import { dispatch, getState } from "../../../state/store";
import { setChallengedUser } from "../../../state/ducks";
import { selectChallengedUser } from "../../../state/selectors/auth";

const signIn = async (username, password) => {
  const user = await Auth.signIn(username, password);

  if (user.challengeName) {
    dispatch(setChallengedUser(user));
  }

  return user.challengeName ? user : null;
};

const signOut = async () => {
  return Auth.signOut();
};

const confirmSignIn = async (user, code, mfaType) => {
  return Auth.confirmSignIn(user, code, mfaType);
};

const changeRequiredPassword = async (user, newPassword) => {
  const challengedUser = selectChallengedUser()(getState());

  return Auth.completeNewPassword(user || challengedUser, newPassword);
};

const forgotPassword = async (username) => {
  return Auth.forgotPassword(username);
};

const forgotPasswordSubmit = async (username, code, password) => {
  return Auth.forgotPasswordSubmit(username, code, password);
};

const setupTotp = async (user) => {
  const challengedUser = selectChallengedUser()(getState());

  return Auth.setupTOTP(user || challengedUser);
};

const verifyTotp = async (user, code) => {
  const challengedUser = selectChallengedUser()(getState());

  return Auth.verifyTotpToken(user || challengedUser, code);
};

const setPreferredMfaType = async (user, mfaType) => {
  const challengedUser = selectChallengedUser()(getState());

  return Auth.setPreferredMFA(user || challengedUser, mfaType);
};

const currentAuthenticatedUser = () => {
  return Auth.currentAuthenticatedUser();
};

const currentSession = () => {
  return Auth.currentSession();
};

const sendCustomChallengeAnswer = async (user, challengeResponse) => {
  await Auth.sendCustomChallengeAnswer(user, challengeResponse);
};

const getAwsCredentials = async () => {
  return await Auth.currentCredentials();
};

const awsAmplifyService = {
  signIn,
  signOut,
  confirmSignIn,
  changeRequiredPassword,
  forgotPassword,
  forgotPasswordSubmit,
  setupTotp,
  verifyTotp,
  setPreferredMfaType,
  currentAuthenticatedUser,
  currentSession,
  sendCustomChallengeAnswer,
  getAwsCredentials
};

export default awsAmplifyService;
